import { ROLE } from '@cmoh/shared'
import { createElement } from 'react'
import { RouteErrorBoundary } from '@/components/shared/RouteErrorBoundary'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const IntegrationsPage = lazyWithRetry(() =>
  import('./pages/IntegrationsPage').then((module) => ({ default: module.IntegrationsPage })),
)

const routes: AppRoute[] = [
  {
    path: 'integrations',
    element: IntegrationsPage,
    errorElement: createElement(RouteErrorBoundary),
    meta: {
      title: 'integrations.title',
      require: { minRole: ROLE.MEMBER },
    },
  },
]

export default routes
